import React from 'react';
import { motion } from 'framer-motion';
import { TagIcon, LayoutGridIcon, BadgeCheckIcon, TruckIcon } from 'lucide-react';
const props = [{
  icon: TagIcon,
  title: 'Beste prijzen',
  text: 'Scherpe groothandelsprijzen voor al onze productcategorieën.'
}, {
  icon: LayoutGridIcon,
  title: 'Ruim assortiment',
  text: 'Voeding, dranken, artikelen voor huis en elektronica op één plek.'
}, {
  icon: BadgeCheckIcon,
  title: 'Gegarandeerde kwaliteit',
  text: 'Zorgvuldig geselecteerde en gecontroleerde producten voor het beste aanbod.'
}, {
  icon: TruckIcon,
  title: 'Snelle levering',
  text: 'Uw bestellingen worden snel voorbereid en geleverd.'
}];
export function ValueProps() {
  return <section className="w-full bg-white py-16" data-id="element-121" data-mp="2sb3m2z60ujqj">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-122" data-mp="1uueoxis0o5nh">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-123" data-mp="1ursenbdqrc1k">
          {props.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="rounded-2xl border border-slate-100 bg-slate-50 p-6 text-center" data-id="element-124" data-mp="1mapp3khh94fe" data-mpi={i}>
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-ardis-green/10 text-ardis-green" data-id="element-125" data-mp="yjjyqbdwutqu">
                <p.icon className="h-7 w-7" aria-hidden="true" data-id="element-126" data-mp="tnv66s0b6d41" />
              </div>
              <h3 className="mt-4 font-display text-lg font-bold text-slate-900" data-id="element-127" data-mp="op1sayh40k3c">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-128" data-mp="2j0ylavv79y0i">
                {p.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}